import React from 'react';

interface IPropsSelf {
    href: string;
    children?: React.Component<any, any>;
    onClick?: (e: Readonly<IPropsSelf>) => void;
    className?: string;
    history?: any;
    followLink?: boolean;
    id?: string;
    forceReload?: boolean;
    target: string;
    anchorLinksCaTriggered: any;
}

export class Link extends React.Component<IPropsSelf> {
    render() {
        const props = this.props;
        const context = this.context as any;
        const click = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
            if (context.track) {
                context.track();
            }
            if (props.followLink) {
                return;
            }
            // ab testing for cruiseaway popunder
            if (props.anchorLinksCaTriggered) {
                return;
            }
            if (!props.forceReload && props.history) {
                e.preventDefault();
                props.history.push(props.href);
                if (props.onClick) {
                    props.onClick(props);
                }
            }
        };
        return (
            <a
                href={props.href}
                className={props.className}
                id={props.id}
                onClick={click}
                target={props.target}
            >
                {props.children as any}
            </a>
        );
    }
}
